import { UTR_RECONCILIATION } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const GetUtrReConiliation = (payload) => {
  return apiInstance.post(UTR_RECONCILIATION, payload);
};
